import { GLOBAL_ASSETS_SENTINEL_OWNER_ID } from '@cadstrom/cadstrom-shared';

/**
 * Drops sentinel organizations (e.g. the global-assets sentinel used to ascribe global
 * ownership of assets) from an org list, leaving only real tenant organizations. Use
 * anywhere an org list is shown to users, except when the sentinel is an intended
 * selectable value (package owner assignment).
 *
 * @param orgs - The list of organizations to filter.
 * @returns A new array containing only real (non-sentinel) organizations.
 */
export function filterRealOrganizations<T extends { id: string }>(orgs: readonly T[]): T[] {
	return orgs.filter((o) => o.id !== GLOBAL_ASSETS_SENTINEL_OWNER_ID);
}
